import { render, staticRenderFns } from "./AsDetailForPush.vue?vue&type=template&id=541fda19"
import script from "./AsDetailForPush.vue?vue&type=script&lang=js"
export * from "./AsDetailForPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports